'use client';
import Image from 'next/image';
import React, { useState } from 'react';

type SocialLinkGroupProps = Record<string, string>;

const SocialLinkGroup = (props: SocialLinkGroupProps) => {
  const [iconFormat, setIconFormat] = useState(`webp`);

  return (
    <div className='sociallinkgroup-container'>
      {Object.keys(props).map((socialNetwork) => {
        const url = props[socialNetwork];
        return url && url.length > 0 ? (
          <a
            href={!url.startsWith('http') ? `//${url}` : url}
            target='_blank'
            rel='noopener noreferrer'
            className='author-table__header-icon'
            key={socialNetwork}
          >
            <Image
              src={`/static/imgs/icons/side-${socialNetwork}.${iconFormat}`}
              alt={`${socialNetwork} icon`}
              fill={true}
              onError={() => setIconFormat('svg')}
            />
          </a>
        ) : null;
      })}
    </div>
  );
};

export default SocialLinkGroup;
